import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { database } from '../firebase';
import { ref, get, child } from 'firebase/database';
const Partnerships = ({ title, description }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [partnerships, setPartnerships] = useState([]);
  useEffect(() => {
    const dbRef = ref(database, 'partnerships');
    get(dbRef).then((snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const partnershipArray = [];
        for (let key in data) {
          if (key.startsWith('partnership') && key !== 'folderCount') {
            partnershipArray.push(data[key]);
          }
        }
        setPartnerships(partnershipArray);
      }
    }).catch((error) => {
      console.error(error);
    });

    // Apply transition after component mounts
    setIsVisible(true);
  }, []);

  return (
    <>
    <Helmet>
    <title>{title || 'Partnerships - EnbyBase Official Website'}</title>
    <meta name="description" content={description || 'Partnerships List of EnbyBase • TransBase'} />
    <meta property="og:title" content={title || 'Partnerships - EnbyBase Official Website'}/>
    <meta property="og:description" content={description || 'Partnerships List of EnbyBase • TransBase'}/>
  </Helmet>

      <article
        className="d-flex flex-column align-items-center container departments-layout"
        style={{
          boxSizing: "border-box",
          width: "100%",
          paddingRight: "var(--bs-gutter-x,.75rem)",
          paddingLeft: "var(--bs-gutter-x,.75rem)",
          marginRight: "auto",
          marginLeft: "auto",
          maxWidth: "1400px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          fontFamily: 'Rubik-Regular'
        }}
      >
        <h1
          className="h2 mt-5 mb-3"
          style={{
            boxSizing: "border-box",
            fontWeight: 500,
            lineHeight: 1.2,
            fontSize: "2.125rem",
            marginTop: "3rem",
            marginBottom: "1rem",
          }}
        >
          {" "}
          Partnerships
        </h1>
        <div
          className="mt-3 mb-4 departments-search-container align-items-center d-flex"
          style={{
            boxSizing: "border-box",
            border: "1px solid transparent",
            borderRadius: "30px",
            padding: "0px 0.25rem",
            backgroundColor: "rgb(255, 255, 255)",
            boxShadow: "rgba(0, 0, 0, 0.06) 0px 4px 10px 0px",
            height: "40px",
            width: "576px",
            display: "flex",
            alignItems: "center",
            marginTop: "1rem",
            marginBottom: "1.5rem",
            fontFamily: 'Rubik-Regular'
          }}
        >
          <input
            id="departments-search"
            type="search"
            autoComplete="off"
            placeholder="Search for partner communities or organisations"
            style={{
              boxSizing: "border-box",
              margin: "0px",
              fontFamily: "inherit",
              fontSize: "inherit",
              lineHeight: "inherit",
              outlineOffset: "-2px",
              appearance: "textfield",
              border: "0px",
              borderRadius: "30px",
              paddingInline: "1.5rem 0.5rem",
              color: "rgb(12, 48, 88)",
              width: "calc(100% - 32px)",
            }}
          />
          <button
            className="pe-none"
            aria-disabled="true"
            tabIndex="-1"
            style={{
              boxSizing: "border-box",
              margin: "0px",
              fontFamily: "inherit",
              fontSize: "inherit",
              lineHeight: "inherit",
              textTransform: "none",
              appearance: "button",
              cursor: "pointer",
              border: "0px",
              borderRadius: "48px",
              backgroundColor: "rgb(234, 235, 237)",
              height: "32px",
              width: "32px",
              pointerEvents: "none",
            }}
          >
            <svg
              height="19px"
              width="19px"
              aria-hidden="true"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              style={{
                boxSizing: "border-box",
                verticalAlign: "middle",
                height: "16px",
                width: "16px",
              }}
            >
              <defs style={{ boxSizing: "border-box" }}>
                <path
                  id="search-path-1"
                  d="M5,11 C5,7.691 7.691,5 11,5 C14.309,5 17,7.691 17,11 C17,14.309 14.309,17 11,17 C7.691,17 5,14.309 5,11 M20.707,19.293 L17.312,15.897 C18.365,14.543 19,12.846 19,11 C19,6.589 15.411,3 11,3 C6.589,3 3,6.589 3,11 C3,15.411 6.589,19 11,19 C12.846,19 14.543,18.365 15.897,17.312 L19.293,20.707 C19.488,20.902 19.744,21 20,21 C20.256,21 20.512,20.902 20.707,20.707 C21.098,20.316 21.098,19.684 20.707,19.293"
                  style={{ boxSizing: "border-box" }}
                />
              </defs>
              <g
                id="search"
                fill="none"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
                style={{ boxSizing: "border-box" }}
              >
                <mask
                  id="mask-2"
                  fill="white"
                  style={{ boxSizing: "border-box" }}
                >
                  <use
                    xlinkHref="#search-path-1"
                    style={{ boxSizing: "border-box" }}
                  />
                </mask>
                <use
                  id="search"
                  fill="currentcolor"
                  fillRule="nonzero"
                  xlinkHref="#search-path-1"
                  style={{ boxSizing: "border-box" }}
                />
              </g>
            </svg>
          </button>
        </div>
        <div
          className="w-100"
          style={{ boxSizing: "border-box", width: "100%" }}
        >
          <div
            id="dc-nav-filter"
            className="src_carousel_container__swRSG src_ltr__Mgt0- src_hide_disabled__wZg8x"
            style={{
              boxSizing: "border-box",
              position: "relative",
              textAlign: "start",
              width: "100%",
              marginBottom: "2rem",
            }}
          >
            <nav
              className="row mx-n3 mx-lg-0 src_tags__tzFGb src_gov_carousel__WJu0L src_mobile_only__bAXtM"
              style={{
                boxSizing: "border-box",
                display: "flex",
                marginTop: "calc(0 * -1)",
                overflow: "scroll",
                scrollbarWidth: "none",
                justifyContent: "center",
                marginRight: "0px",
                marginLeft: "0px",
                flexWrap: "wrap",
              }}
            >
              <a
                className="src_active__Eaa5o src_tag__Gw3Y0 user-select-none w-auto"
                aria-current="page"
                href="/partnerships"
                target="_self"
                style={{
                  boxSizing: "border-box",
                  flexShrink: 0,
                  maxWidth: "100%",
                  background:
                    "0px 0px no-repeat padding-box padding-box rgb(240, 242, 245)",
                  border: "none",
                  margin: "0.5rem 0.25rem",
                  textDecoration: "none",
                  whiteSpace: "nowrap",
                  alignItems: "center",
                  display: "flex",
                  marginTop: "0.5rem",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  font: "16px / 40px FoundryContextW03Md",
                  height: "36px",
                  borderRadius: "18px",
                  backgroundColor: "rgb(156,89,209)",
                  color: "rgb(255, 255, 255)",
                  width: "auto",
                  userSelect: "none",
                  outline: "rgb(156,89,209) 0px",
                }}
              >
                <span style={{ boxSizing: "border-box" }}>All</span>
              </a>
              <a
                className="src_tag__Gw3Y0 user-select-none w-auto"
                aria-current="page"
                href="/partnerships?type=1"
                target="_self"
                style={{
                  boxSizing: "border-box",
                  flexShrink: 0,
                  maxWidth: "100%",
                  background:
                    "0px 0px no-repeat padding-box padding-box rgb(240, 242, 245)",
                  border: "none",
                  borderRadius: "18px",
                  margin: "0.5rem 0.25rem",
                  textDecoration: "none",
                  whiteSpace: "nowrap",
                  alignItems: "center",
                  color: "rgb(12, 48, 88)",
                  display: "flex",
                  marginTop: "0.5rem",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  font: "16px / 40px FoundryContextW03Md",
                  height: "36px",
                  backgroundColor: "rgb(255, 255, 255)",
                  width: "auto",
                  userSelect: "none",
                }}
              >
                <span style={{ boxSizing: "border-box" }}>
                  Discord Servers
                </span>
              </a>
              <a
                className="src_tag__Gw3Y0 user-select-none w-auto"
                aria-current="page"
                href="/partnerships?type=2"
                target="_self"
                style={{
                  boxSizing: "border-box",
                  flexShrink: 0,
                  maxWidth: "100%",
                  background:
                    "0px 0px no-repeat padding-box padding-box rgb(240, 242, 245)",
                  border: "none",
                  borderRadius: "18px",
                  margin: "0.5rem 0.25rem",
                  textDecoration: "none",
                  whiteSpace: "nowrap",
                  alignItems: "center",
                  color: "rgb(12, 48, 88)",
                  display: "flex",
                  marginTop: "0.5rem",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  font: "16px / 40px FoundryContextW03Md",
                  height: "36px",
                  backgroundColor: "rgb(255, 255, 255)",
                  width: "auto",
                  userSelect: "none",
                }}
              >
                <span style={{ boxSizing: "border-box" }}>
                  Subreddits
                </span>
              </a>
              <a
                className="src_tag__Gw3Y0 user-select-none w-auto"
                aria-current="page"
                href="/partnerships?type=3"
                target="_self"
                style={{
                  boxSizing: "border-box",
                  flexShrink: 0,
                  maxWidth: "100%",
                  background:
                    "0px 0px no-repeat padding-box padding-box rgb(240, 242, 245)",
                  border: "none",
                  borderRadius: "18px",
                  margin: "0.5rem 0.25rem",
                  textDecoration: "none",
                  whiteSpace: "nowrap",
                  alignItems: "center",
                  color: "rgb(12, 48, 88)",
                  display: "flex",
                  marginTop: "0.5rem",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  font: "16px / 40px FoundryContextW03Md",
                  height: "36px",
                  backgroundColor: "rgb(255, 255, 255)",
                  width: "auto",
                  userSelect: "none",
                }}
              >
                <span style={{ boxSizing: "border-box" }}>
                  Civil Organisations
                </span>
              </a>
              <a
                className="src_tag__Gw3Y0 user-select-none w-auto"
                aria-current="page"
                href="/partnerships?type=4"
                target="_self"
                style={{
                  boxSizing: "border-box",
                  flexShrink: 0,
                  maxWidth: "100%",
                  background:
                    "0px 0px no-repeat padding-box padding-box rgb(240, 242, 245)",
                  border: "none",
                  borderRadius: "18px",
                  margin: "0.5rem 0.25rem",
                  textDecoration: "none",
                  whiteSpace: "nowrap",
                  alignItems: "center",
                  color: "rgb(12, 48, 88)",
                  display: "flex",
                  marginTop: "0.5rem",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  font: "16px / 40px FoundryContextW03Md",
                  height: "36px",
                  backgroundColor: "rgb(255, 255, 255)",
                  width: "auto",
                  userSelect: "none",
                }}
              >
                <span style={{ boxSizing: "border-box" }}>
                  Creators
                </span>
              </a>
            </nav>
          </div>
        </div>
        <div
          className="departments-results d-flex flex-wrap mt-2 mb-5 pb-4 px-lg-4 w-100"
          style={{
            boxSizing: "border-box",
            display: "flex",
            width: "100%",
            flexWrap: "wrap",
            marginTop: "0.5rem",
            marginBottom: "3rem",
            paddingBottom: "1.5rem",
            paddingRight: "1.5rem",
            paddingLeft: "1.5rem",
          }}
        >


<div className="sfm-partnership-card-wrapper">
      {partnerships.map((partnership, index) => (
        <div className="sfm-content-box-wrapper" key={index}>
          <a href={partnership.serverLink} target="_self" title={partnership.category} className="sfm-link">
            <div className={`sfm-content-box ${isVisible ? 'sfm-visible' : ''}`}>
              <div className="sfm-img-wrapper" aria-hidden="true">
                <img
                  className="sfm-img"
                  src={partnership.ImageLink}
                  alt={`${partnership.partnershipName} Partnership`}
                />
              </div>
              <div className="sfm-title-wrapper">
                <h3 className="h320a-pt">{`${partnership.partnershipName} (${partnership.category})`}</h3>
              </div>
            </div>
          </a>
        </div>
      ))}
    </div>

        </div>
      </article>
    </>
);
}

export default Partnerships;